const state = {
  increaseBoard: {
    studentNum: '',
    classNum: ''
  },
  teacherCharts: [],
  classCharts: [],
  studentGrowthCharts: [],
  workAverageCharts: [],
  studentsWorkCharts: [],
  studentCompareCharts: [],
  cityWorksCharts: [],
  mapName: {}
}

const actions = {}

const mutations = {}

export default {
  state,
  actions,
  mutations
}
